import React, { FC } from 'react';
import '../styles/login.css';
import { Button } from 'react-bootstrap';
import logo from '../img/CCCR-registration.svg';
import firebase from "firebase/compat/app";
import 'firebase/compat/auth';

const Login: FC = () => {
    return (
        <div className="wrapper">
            <div className="text-center signin">
                <img className="logo" src={logo} alt="logo" />
                <Button className="btn btn-lg btn-primary btn-block" onClick={() => {
                    const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
                    googleAuthProvider.setCustomParameters({
                        prompt: 'select_account'
                    });
                    firebase.auth().signInWithRedirect(googleAuthProvider);
                }} >Login</Button>
            </div>
        </div>
    )
}

export default Login;
